// @ts-nocheck

import Client from '../client';
import { makeWapiCall } from '../utils/api';

/** Detection duration for the rate limit in ms */
const RATE_LIMIT_DURATION = 60 * 1000;

/** Max number of request to the reporting service for the rate limit duration */
const RATE_LIMIT_COUNT = 20;

/** Rate limit start of the timestamp  */
let rateLimitTimestamp: number = 0;

/** Number of current requests for the rate limit */
let rateLimitCount: number = 0;

/** Indicate if the rate limit has been reached */
let rateLimitReached: boolean = false;

const checkRateLimit = (): boolean => {
  if (rateLimitReached) {
    // User has reached his rate limit, don't send report for this session
    return false;
  }

  const now = Math.floor(Date.now() / 1000);

  if (!rateLimitTimestamp) {
    // Init timestamp of detection
    rateLimitTimestamp = now;
  }

  if (now > rateLimitTimestamp + RATE_LIMIT_DURATION) {
    // Rate limit is not exceeded in the period, a new cycle is restarted
    rateLimitTimestamp = now;
    rateLimitCount = 1;
  } else {
    // Count the new request for the period
    ++rateLimitCount;

    // Check if rate limit has been reached
    if (rateLimitCount >= RATE_LIMIT_COUNT) {
      // Rate limit reached
      rateLimitReached = true;
      return false;
    }
  }

  // Rate limit not reached
  return true;
};

const Reporter = {};

Reporter.sendReport = (data, jwt) => {
  if (checkRateLimit()) {
    const reportParams = {
      jwt,
      tracker: Client.tracker,
      context: 'betting',
      version: Client.bettingVersion,
      data,
    };

    makeWapiCall({
      namespace: 'betting/reporter',
      method: 'SendReport',
      params: reportParams,
    });
  }
};

export default Reporter;
